import Vue from 'vue'
import { cliente as routing } from '../util/routes'
import pdfMake, { styles, pageConfig } from '@/plugins/pdf'

export default {
  state: {
    cliente: {},
    clientes: [],
    paginateClientes: {
      data: []
    },
    clientePage: 1,
    clienteFilter: ''
  },
  mutations: {
    setCliente: (state, payload) => {
      state.cliente = payload
    },
    setClientes: (state, payload) => {
      state.clientes = payload
    },
    setClientePage: (state, payload = 1) => {
      state.clientePage = payload
    },
    setClienteFilter: (state, payload = '') => {
      state.clienteFilter = payload
    },
    setPaginateClientes: (state, payload) => {
      state.paginateClientes = payload
    },
    setPaginateClientesStatus: (state, payload) => {
      state.paginateClientesStatus = payload
    }
  },
  actions: {
    async getPaginateClientes ({ commit, state }, payload) {
      commit('setPaginateClientes', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.clientePage,
          filter: state.clienteFilter
        }
      })
      commit('setPaginateClientes', data)
    },
    async getClientes ({ commit, state }, payload) {
      commit('setClientes', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0
        }
      })
      commit('setClientes', data)
    },
    async getClientesToPrintAnexoIVEmBranco ({ commit }, payload) {
      commit('setClientes', {})
      const { data } = await Vue.axios.get(`${routing}/anexo-iv`, {
        headers: {
          ...payload
        }
      })
      commit('setClientes', data)
    },
    async getCliente ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setCliente', data)
    },
    async postSaveCliente ({ state }) {
      const { cliente } = state
      if (cliente.id) {
        return Vue.axios.put(`${routing}/${cliente.id}`, cliente)
      }
      return Vue.axios.post(`${routing}`, cliente)
    },
    async deleteCliente ({ state }) {
      const { cliente } = state
      return Vue.axios.delete(`${routing}/${cliente.id}`)
    },
    async printClientesAnexoIVEmBranco (
      { commit, state },
      { clientes, industria }
    ) {
      await Vue.axios
        .post(`documentos/clientes/anexo-ix/incompleto`, {
          clientes,
          industria
        })
        .then(({ data: content }) => {
          const docDefinition = {
            ...pageConfig,
            styles,
            content
          }
          return pdfMake.createPdf(docDefinition).open()
        })
        .catch(error => {
          alert(
            `Ocorreu um erro durante o processamento dos clientes para impressão => ${error.data.error.message} [${error.data.error.status}]`
          )
          return console.error(error)
        })
    }
  },
  getters: {
    cliente: ({ cliente }) => cliente,
    clientes: ({ clientes }) => clientes,
    clientePage: ({ clientePage }) => clientePage,
    clienteFilter: ({ clienteFilter }) => clienteFilter,
    paginateClientes: ({ paginateClientes }) => paginateClientes,
    paginateClientesStatus: ({ paginateClientesStatus }) =>
      paginateClientesStatus
  }
}
